var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container row-v2"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"col__box"},[_vm._v(" Series: "+_vm._s(_vm.series.name)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }